import React, { FC, useState, useEffect, useRef } from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'

interface SelectOption {
  value: string
  label: string
}

interface SelectInputProps {
  register: UseFormRegisterReturn
  options: SelectOption[]
  placeholder?: string
  width?: number | string
  className?: string
  value?: string
}

export const SelectInput: FC<SelectInputProps> = ({
  register,
  options,
  placeholder = '選択してください',
  width = undefined,
  className = '',
  value = '',
}) => {
  const [selectedValue, setSelectedValue] = useState(value || '')
  const selectRef = useRef<HTMLSelectElement | null>(null)

  useEffect(() => {
    // 初期値を設定
    if (value) {
      setSelectedValue(value)
    }
    // マウント後に実際の値をチェック
    const timer = setTimeout(() => {
      if (selectRef.current) {
        setSelectedValue(selectRef.current.value)
      }
    }, 0)
    return () => clearTimeout(timer)
  }, [value])

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedValue(e.target.value)
    register.onChange(e)
  }

  const handleRef = (element: HTMLSelectElement | null) => {
    selectRef.current = element
    register.ref(element)
    // 要素がマウントされた時に実際の値を取得
    if (element && element.value) {
      setSelectedValue(element.value)
    }
  }

  const isPlaceholderSelected = selectedValue === ''

  const { ref, ...registerWithoutRef } = register

  return (
    <div
      className={`relative ${className || 'w-full'}`}
      style={className && className.includes('w-') ? {} : { width }}
    >
      <select
        ref={handleRef}
        className={`w-full pl-3 pr-10 py-2 border border-main-bordergray rounded-md focus:outline-none focus:border-2 focus:border-main-green appearance-none ${
          isPlaceholderSelected ? 'text-main-bordergray' : 'text-black'
        }`}
        {...registerWithoutRef}
        onChange={handleChange}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <span className="material-icons absolute right-3 top-1/2 transform -translate-y-1/2 text-main-darkgray pointer-events-none">
        expand_more
      </span>
    </div>
  )
}
